import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "31",
  fill: "none",
  viewBox: "0 0 30 31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M28.5 28a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3zm0-14a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3zm0-14a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 1 1 0-3z"
    }, null, -1)
  ]))]))
}
export default { render: render }